module.exports = __webpack_public_path__ + "static/media/index.810ad2f3.less";